import type { ReactNode } from "react";
import { View } from "react-native";
import { BodyText, Subtitle } from "~/components/layout/text";
import { Only } from "~/components/permission/Only";
import { Gap, Padding } from "~/constants/layout";

type DataListItemProps = {
    title?: string;
    data?: ReactNode;
    children?: ReactNode;
};

export const DataListItem = ({ title, data, children }: DataListItemProps) => {
    return (
        <View style={[Gap.row_xxx, Padding.sm]}>
            <Only when={title}>
                <Subtitle>{title}</Subtitle>
            </Only>
            <BodyText>{children || data || "-"}</BodyText>
        </View>
    );
};
